<template>
  <div id="capacitacion">
    <div id="destaca">
        <div class="capac" v-for="dest in destacadas" :key="dest.id">
            <div class="top">
                <p class="eti">{{ dest.etiqueta }}</p>
                <p class="fecha">{{ dest.fecha }}</p>
            </div>
            <h3 class="titu">{{ dest.titulo }}</h3>
            <img class="foto" :src="getImgUrl(dest.foto)" :alt="dest.titulo">
            <div class="capaTex">
                <p class="tex" ref="eld">{{ textoSin() }}</p>
            </div>
        </div>
    </div>
    <div id="capas">
        <div class="capac" v-for="capa in capas" :key="capa.id">
            <div class="top">
                <p class="eti">{{ capa.etiqueta }}</p>
                <p class="fecha">{{ capa.fecha }}</p>
            </div>
            <h4 class="titu">{{ capa.titulo }}</h4>
            <img class="foto" :src="getImgUrl(capa.foto)" :alt="capa.titulo">
            <div class="capaTex">
                <p class="tex" ref="elc">{{ textoSinC() }}</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        capacitaciones: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            destacadas: [],
            capas: []
        }
    },
    mounted(){
        this.destaca()
    },
    methods: {
        textoSin(){
            setTimeout(() => {
                let pTexto = this.$refs.eld;
                for (let i = 0; i < pTexto.length; i++) {
                    if(this.capacitaciones[i].texto){
                        pTexto[i].innerHTML = this.capacitaciones[i].texto
                    }
                }
            }, 300);
        },
        textoSinC(){
            setTimeout(() => {
                let pTexto = this.$refs.elc;
                for (let i = 0; i < pTexto.length; i++) {
                    if(this.capacitaciones[i].texto){
                        pTexto[i].innerHTML = this.capacitaciones[i].texto
                    }
                }
            }, 300);
        },
        getImgUrl(img) {
            if(img !== undefined){
                let images = require.context('../assets/capac/', false, /\.jpg$/)
            return images('./' + img + '.jpg')
            }
        },
        destaca(){
        let desta = []
        let cap = []
        this.capacitaciones.forEach((d) => {
            if(d.destacado == 'si'){
                desta.push(d)
            } else {
                cap.push(d)
            }
        })
        this.destacadas = desta
        this.capas = cap
        },
    }
}
</script>

<style lang="scss" scoped>
#capacitacion{
    width: 100%;
    max-width: 1000px;
    margin: 50px auto;

    #destaca, #capas {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
        gap: 50px 20px;
        
        .top{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            margin: 10px auto 30px;
            .eti{
                text-transform: uppercase;
                color: var(--medium-gray);
                padding: 5px 10px;
                border: 1px solid var(--medium-gray);
                margin: 0 auto 10px 0;
                font-size: .8rem;
                width: fit-content;
            }
            .fecha{
                color: var(--medium-gray);
                padding: 5px 10px;
                margin: 0 0 10px auto;
                font-size: .9rem;
                text-align: right;
                width: fit-content;
                position: relative;
                &:after {
                    content: '';
                    width: 0;
                    height: 0;
                    position: absolute;
                    top: 9px;
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    border-right: 5px solid var(--medium-gray);
                    // border-left: 5px solid transparent;
                    right: 0px;
                }
            }
        }

        .foto{
            width: 100%;
            margin: 30px auto 10px;
        }
        .capac {
            width: 90%;
            margin: auto;
            border-bottom: 2px solid var(--sate);
            position: relative;

            &:before{
                content: '';
                width: 40px;
                height: 40px;
                // border-radius: 50%;
                background-color: var(--white);
                position: absolute;
                left: 50%;
                bottom: -15px;
                transform: translateX(-50%);
            }
            &:after{
                content: '';
                position: absolute;
                left: 50%;
                bottom: -19px;
                // background-color: var(--sate);
                transform: translateX(-50%);
                width: 0px;
                height: 0px;
                // top: -2px;
                border-top: 10px solid var(--sate);
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 10px solid transparent;
            }

            &:last-child{
                border-bottom: 2px solid var(--white);
                margin-bottom: 100px;
                &:before, &:after{
                    display: none;
                }
            }
            .titu{
                @media screen and (max-width: 400px) {
                    font-size: var(--t4);
                }
            }
            .capaTex{
                margin: 20px auto 50px;
                .tex{
                    // width: 90%;
                    margin: auto;
                }
            }
        }
    }
    #capas {
        flex-flow: row wrap;
        .capac{
            width: 40%;
            padding-top: 30px;
            margin-top: 0;
            border-bottom: 2px solid var(--white);
            border-top: 2px solid var(--sate);
            @media screen and (max-width: 600px) {
                width: 90%;
            }
            &:before{
                top: -15px;
            }
            &:after{
                top: -2px;
            }
            &:last-child{
                // border-bottom: 2px solid var(--white);
                margin-bottom: 50px;
                &:before, &:after{
                    display: block;
                }
            }
            .titu{
                text-align: left;
            }
        }
    }
}
</style>